import React from "react";

const tools = [
  { icon: "🛠️", title: "Chart Analysis", desc: "Break down candlesticks, trends, and levels using AI." },
  { icon: "📚", title: "Concept Reinforcement", desc: "Get beginner-friendly explanations of complex ideas." },
  { icon: "🧪", title: "Strategy Testing", desc: "Simulate and get feedback on your trade logic." },
  { icon: "📈", title: "Price Pattern Scanning", desc: "Detect patterns automatically across timeframes." },
  { icon: "🧭", title: "Guided Learning", desc: "Follow personalized learning journeys suggested by AI." },
  { icon: "💬", title: "Contextual Q&A", desc: "Ask questions and receive instant answers from chart context." },
];

const AgentToolsSection = () => {
  return (
    <section className="why-choose">
      <h3>Explore FinTorro AI Capabilities</h3>
      <div className="benefits-grid">
        {tools.map((tool, index) => (
          <div className="benefit-item" key={index}>
            <strong>{tool.icon} {tool.title}</strong>
            <p>{tool.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AgentToolsSection;
